import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { setLenis } from "@/lib/scroll";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Vision from "@/components/Vision";
import Comparison from "@/components/Comparison";
import About from "@/components/About";
import Features from "@/components/Features";
import Benefits from "@/components/Benefits";
import Showcase from "@/components/Showcase";
import GoogleSection from "@/components/GoogleSection";
import Industries from "@/components/Industries";
import Pricing from "@/components/Pricing";
import Privacy from "@/components/Privacy";
import Portfolio from "@/components/Portfolio";
import Blog from "@/components/Blog";
import FinalCTA from "@/components/FinalCTA";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        setLenis(lenis);
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            setLenis(null);
        };
    }, []);

    return (
        <div className="min-h-screen bg-[#050B14] text-slate-100">
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <Vision />
                <Comparison />
                <About />
                <Features />
                <Benefits />
                <Showcase />
                <GoogleSection />
                <Industries />
                <Pricing />
                <Privacy />
                <Portfolio />
                <Blog />
                <FinalCTA />
                <Contact />
            </main>
            <Footer />
            <WhatsAppFloat />
            <Toaster theme="dark" position="bottom-center" richColors />
        </div>
    );
}

export default App;
